import React, { createContext, useState, useEffect } from 'react';
import { servicesAPI, projectsAPI, testimonialsAPI } from '../utils/api';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [services, setServices] = useState([]);
  const [projects, setProjects] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const [servicesRes, projectsRes, testimonialsRes] = await Promise.all([
        servicesAPI.getAll().catch(err => {
          console.error('Services API Error:', err.message);
          return { data: { data: [] } };
        }),
        projectsAPI.getAll({ featured: true }).catch(err => {
          console.error('Projects API Error:', err.message);
          return { data: { data: [] } };
        }),
        testimonialsAPI.getAll().catch(err => {
          console.error('Testimonials API Error:', err.message);
          return { data: { data: [] } };
        })
      ]);

      setServices(servicesRes.data.data || []);
      setProjects(projectsRes.data.data || []);
      setTestimonials(testimonialsRes.data.data || []);
      
      console.log('✅ Data loaded successfully:', {
        services: servicesRes.data.data?.length || 0,
        projects: projectsRes.data.data?.length || 0,
        testimonials: testimonialsRes.data.data?.length || 0
      });
    } catch (error) {
      console.error('❌ Error fetching data:', error);
      setError(error.message);
      // Set empty arrays as fallback
      setServices([]);
      setProjects([]);
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppContext.Provider value={{
      services,
      projects,
      testimonials,
      loading,
      error,
      fetchData
    }}>
      {children}
    </AppContext.Provider>
  );
};